import { IPackagesRepository } from '../libraries/packages'
import { useEffect, useMemo, useState } from 'react'
import { localRepoInstance, PackagesRepositoryZustand } from '../libraries/packages.local.repository'
import { useAuth } from '../components/AuthProvider'
import { PackagesRepositoryFirebase } from '../libraries/packages.remote.repository'
import { firestoreInstance } from '../libraries/firebase'

const usePackagesRepository = (): IPackagesRepository => {
  const { authUser } = useAuth()

  const remoteRepo = useMemo(() => {
    if (authUser) {
      return new PackagesRepositoryFirebase(authUser.uid, firestoreInstance)
    }
  }, [authUser])

  const [currentRepo, setCurrentRepo] = useState<IPackagesRepository>(remoteRepo ?? localRepoInstance)

  // update current repo in case there are changes on the remote repo
  useEffect(() => {
    // on login, we have a remote repo
    if (remoteRepo && currentRepo instanceof PackagesRepositoryZustand) {
      console.log('Setting currentRepo to firebase')
      setCurrentRepo(remoteRepo)
    }

    // on logout we should use the local repo
    if (!remoteRepo && currentRepo instanceof PackagesRepositoryFirebase) {
      setCurrentRepo(localRepoInstance)
    }
  }, [currentRepo, remoteRepo])

  useEffect(() => {
    console.log('current repo is', currentRepo?.constructor?.name)
  }, [currentRepo])

  return currentRepo
}

export default usePackagesRepository
